import TeamOnboardingImage from '../../../assets/team-onboarding.svg';
import { OnboardingLayout } from '../OnboardingLayout';

export const Welcome = () => {
    return (
        <OnboardingLayout currentStep={0} onNextLabel="Begin setup">
            <div>
                <center><h1>Set up the Rovo App for Slack</h1></center>
                <TeamOnboardingImage />
                <center><p>Install the Rovo app for Slack and connect your Atlassian site.</p></center>
            </div>
        </OnboardingLayout>
    );
};